import { useContext } from 'react'

import { PopupPositionContext } from 'core-components/library/popup'

import { DropdownArrow } from './DropdownArrow'

interface IDropdownArrow {
  state: 'up' | 'down'
}
export const DropdownArrowWithContext = ({ state }: IDropdownArrow) => {
  const PositionContext = useContext(PopupPositionContext)

  return (
    <DropdownArrow
      state={state}
      onMouseDown={(event) => {
        if (state === 'up') {
          event.stopPropagation()
          event.preventDefault()

          PositionContext.action.close()
        }
      }}
    />
  )
}
